import axios from "axios";
import {devLog} from "../../../../../utils/devLog/devLog";

export {fetchPools};

const fetchPools = async(setFetchStatusPools: Function, setPools: Function) => {
  try {
    setFetchStatusPools("fetching");
    const fetched = await axios.get(`${process.env.REACT_APP_API_URL}/pool/m/pools`, {withCredentials: true});
    if(fetched.data.status !== "ok") {
      return setFetchStatusPools("error");
    }
    setPools(fetched.data.data);
    setFetchStatusPools("fetched");
    return fetched.data.data;
  } catch (error) {
    devLog(error);
    setFetchStatusPools("error");
  }
}